module.exports = __webpack_public_path__ + "img/Korea Food Sanitation Act.b68115d3.png";